var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"height":"100vh"},attrs:{"src":require("@/assets/survey/poster.jpg"),"alt":"포스터"}})
}
var staticRenderFns = []

export { render, staticRenderFns }